import { render, staticRenderFns } from "./password-prompt.vue?vue&type=template&id=0f08c07c&scoped=true"
import script from "./password-prompt.vue?vue&type=script&lang=js"
export * from "./password-prompt.vue?vue&type=script&lang=js"
import style0 from "./password-prompt.vue?vue&type=style&index=0&id=0f08c07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f08c07c",
  null
  
)

export default component.exports